import { z } from 'zod';

/** The deployment stage a server or web build is running in (D-035). */
export const EnvironmentSchema = z.enum(['local', 'dev', 'staging', 'prod']);
export type Environment = z.infer<typeof EnvironmentSchema>;
